import { MessageCircle } from 'lucide-react'

import { ContactSupportAction } from '@/customer/components/contact-support-action'
import { StackedHeadline } from '@/customer/components/stacked-headline'
import { Alert, AlertAction, AlertDescription, AlertTitle } from '@/customer/components/ui/alert'

/**
 * Full-page fallback for when `/portal/me` (or the account-status
 * rollup) can't be resolved for a signed-in member - a missing
 * member row, a backend outage, or a transient network error.
 *
 * Deliberately static: no retry, no sign-out. We treat the situation
 * as "your account is fine, our system needs a moment"; the copy
 * reassures the member that the team is aware and can help via
 * WhatsApp if they need to reach us.
 */
export function AccountFetchError() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-10 p-8 text-center">
      <StackedHeadline align="center" lines={[{ text: 'Oops', color: 'destructive' }]} />

      <div className="flex max-w-md flex-col gap-4">
        <p className="text-headline-md leading-tight">We had some trouble fetching your account</p>
        <p className="text-body-lg text-muted-foreground">Our tech team has been notified.</p>
      </div>

      <Alert variant="warning" className="w-full max-w-md text-left">
        <MessageCircle />
        <AlertTitle>In the meantime</AlertTitle>
        <AlertDescription>
          For anything urgent, message us on WhatsApp and we'll get you sorted.
        </AlertDescription>
        <AlertAction>
          <ContactSupportAction />
        </AlertAction>
      </Alert>
    </div>
  )
}
